{
  "translation": {
    "button": {
      "ok": "OK",
      "cancel": "Absagen",
      "clear": "Klar",
      "login": "Anmeldung",
      "logout": "Ausloggen",
      "delete": "Löschen",
      "new": "Neu",
      "back": "Zurück",
      "save": "retten",
      "create": "Schaffen",
      "export": "Export",
      "import": "Importieren",
      "upload": "Hochladen",
      "open": "Offen",
      "iframe": "IFrame",
      "newTab": "Neue Registerkarte",
      "search": "Suchen",
      "refresh": "Aktualisierung",
      "compare": "Vergleichen",
      "publish": "Veröffentlichen",
      "discard": "Verwerfen",
      "deleteAll": "Alle Löschen",
      "download": "Herunterladen",
      "generate": "Generieren"
    },
    "tooltip": {
      "enableOptional": "Markiert bedeutet, dass optionale Funktionen im Konfigurator angezeigt werden."
    },
    "dialogBox": {
      "error": "Fehler",
      "success": "Erfolgreich",
      "ConnectionError": "Verbindungsfehler"
    },
    "labels": {
      "lovOptions": "LOV Optionen ({{name}})",
      "description": "Beschreibung",
      "name": "Name",
      "email": "Email",
      "userManagement": "Benutzerverwaltung",
      "roleManagement": "Rollenverwaltung",
      "apiKeyManagement": "API-Schlüsselverwaltung",
      "applicationManagement": "Anwendungsentwicklung",
      "featureFlagsManagement": "Verwaltung von Feature-Flags",
      "personalDetails": "Persönliche Daten",
      "roleAssociation": "Rollenzuordnung",
      "createUser": "Benutzer erstellen",
      "editUser": "Benutzer bearbeiten",
      "isAdmin": "Administrator",
      "createRole": "Rolle erstellen",
      "editRole": "Rolle bearbeiten",
      "isDefault": "Standard",
      "createApiKey": "API-Schlüssel erstellen",
      "editApiKey": "API-Schlüssel bearbeiten",
      "permission": "Erlaubnis",
      "read": "Lesen",
      "write": "Schreiben",
      "yes": "Ja",
      "no": "NEIN",
      "key": "Taste",
      "applicationUrl": "Anwendungs-URL",
      "access": "Erlaubnis",
      "userEmail": "Service-Nutzer",
      "emailId": "Email",
      "isService": "Dienstbenutzer",
      "isPdm": "PDM User",
      "isAce": "Ace User",
      "roles": "Rollen",
      "accessType": "Erlaubnis",
      "isActive": "Aktiv",
      "isHidden": "Versteckt",
      "isEditable": "Editierbar",
      "isVisible": "Zeigen",
      "channels": "Kanäle",
      "deleteConfirm": "Löschen bestätigen",
      "administration": "Verwaltung",
      "dataMaintainance": "Datenwartung",
      "featureFlags": "Feature-Flags",
      "flagName": "Name der Flagge",
      "applicationName": "Name der Anwendung",
      "application": "Name der Anwendung",
      "page": "Seite",
      "configuration": "Aufbau",
      "configurationId": "Konfigurations-ID",
      "token": "Zeichen",
      "language": "Sprache",
      "apiKey": "API-Schlüssel",
      "country": "Land",
      "none": "Keiner",
      "headerLess": "Kopfzeile weniger",
      "note": "Notiz",
      "copyApiKey": "Ich habe den Schlüssel kopiert.",
      "product": "Produkt",
      "id": "Ausweis",
      "code": "Code",
      "productCode": "Produktcode",
      "languages": "Sprachen",
      "recordsPerPage": "Aufzeichnungen",
      "materialCode": "Materialnummer",
      "countryCode": "Landesvorwahl",
      "currencyCode": "Währungscode",
      "price": "Preis",
      "editPriceListMap": "Bearbeiten Sie die Preislistenzuordnung",
      "editLanguageAssociation": "Sprachzuordnung bearbeiten",
      "materialImages": "Bilder",
      "languageCode": "Sprachcode",
      "shortSalesText": "Kurzverkaufstext",
      "longSalesText": "Langer Verkaufstext",
      "view": "Sicht",
      "sc": "SC Code",
      "pd": "PD Code",
      "bs": "BS Code",
      "bu": "BU Code",
      "mag": "MAG Code",
      "ag": "AG Code",
      "image": "Bild",
      "languageManagement": "Sprachmanagement",
      "createLanguage": "Sprache erstellen",
      "editLanguage": "Sprache bearbeiten",
      "supportDetails": "Supportdetails",
      "browserCompatibility": "Browser-Kompatibilität",
      "enableOptional": "Aktivieren Sie optionale Funktionen",
      "apikeyDetails": "Details zum API-Schlüssel",
      "feature": "Merkmale",
      "message": "Nachricht",
      "url": "URL",
      "create": "Erstellen",
      "edit": "Bearbeiten",
      "map": "Preiskarte",
      "newMap": "Neue Preiskarte",
      "productId": "Produktcode",
      "productDescription": "Produktbeschreibung",
      "agCode": "Ag-Code",
      "packageType": "Pakettyp",
      "countries": "Länder",
      "marketManagement": "Marktmanagement",
      "createMarket": "Markt schaffen",
      "editMarket": "Markt bearbeiten",
      "markets": "Märkte",
      "market": "marché",
      "state": "Zustand",
      "createdBy": "Erstellt von",
      "modifiedBy": "Geändert von",
      "deletedBy": "Gelöscht von",
      "createdOn": "Erstellt am",
      "modifiedOn": "Geändert am",
      "versionId": "Version Id",
      "releaseId": "Release Id",
      "deletedOn": "Gelöscht am",
      "lastLogin": "Letzter Login",
      "countryName": "Ländername",
      "packagePath": "Paketpfad",
      "createdFromName": "Erstellt aus dem Namen",
      "createdFromId": "Erstellt aus ID",
      "editMarketAssociation": "Marktverband bearbeiten",
      "permissions": "Berechtigungen",
      "group": "Gruppe",
      "resource": "Ressource",
      "privileges": "Privilegien",
      "properties": "Eigenschaften",
      "compare": "Vergleichen",
      "details": "Einzelheiten",
      "lastUpdatedOn": "Zuletzt aktualisiert am",
      "notificationManagement": "Benachrichtigungsverwaltung",
      "queueManagement": "Warteschlangenverwaltung",
      "releaseManagement": "Produktfreigabeverwaltung",
      "productVersionMappingManagement": "Produktversionszuordnung",
      "notifications": "Benachrichtigung",
      "reports": "Berichte",
      "type": "Typ",
      "targetId": "Ziel-ID",
      "action": "Aktion",
      "refresh": "Aktualisieren",
      "active": "aktiv",
      "status": "Status",
      "processedOn": "Verarbeitet am",
      "log": "Protokoll",
      "sync": "synchronisieren",
      "retrigger": "Erneut auslösen",
      "userAccessType": "Zugriffsarten",
      "propertyManagement": "Immobilienverwaltung",
      "applicability": "Anwendbarkeit",
      "listOfValues": "Liste der Werte",
      "origin": "Herkunft",
      "default": "Default",
      "configit": "Configit",
      "pdm": "PDM",
      "option": "Möglichkeit",
      "selectionType": "Auswahltyp",
      "inactive": "Inaktiv",
      "actions": "Aktionen",
      "valueType": "Werttyp",
      "restrictUpdate": "(Die Auswahl ist irreversibel)",
      "values": "Werte",
      "channel": "Kanal",
      "views": "Sicht",
      "isLocal": "isLokal",
      "multiNumericManagement": "Multinumerische Verwaltung",
      "others": "Andere",
      "columns": "Columns",
      "filters": "Filters",
      "source": "Quelle",
      "txnId": "Transaktions-ID",
      "user": "Benutzer",
      "syncedOn": "Synchronisiert am",
      "error": "Fehler",
      "activities": "Aktivitäten",
      "version": "Version",
      "startedOn": "Gestartet am",
      "remarks": "Bemerkungen",
      "rules": "Regeln",
      "effectivity": "Wirksamkeit",
      "salestext": "Verkaufstext",
      "selectAll": "Alle",
      "download": "Herunterladen",
      "isRequired": "Erforderlich",
      "fromDate": "Von",
      "toDate": "Bis",
      "fileName": "Dateiname",
      "reportManagement": "Berichtsverwaltung",
      "descopeList": "Descope-Liste",
      "coe": "COE",
      "procosForPpl": "ProCoS für PPL",
      "allCommercialItems": "Alle kommerziellen Artikel"
    },
    "header": {
      "image": "Bild",
      "price": "Preis",
      "productHierarchy": "Produkthierarchie",
      "languageAssociation": "Sprachvereinigung",
      "salesText": "Verkaufstext",
      "roles": "Rolle",
      "users": "Benutzer",
      "apikeys": "API-Schlüssel",
      "applications": "Anwendung",
      "channels": "Kanäle",
      "languages": "Sprache",
      "associatedLanguages": "Assoziierte Sprachen",
      "priceListMap": "Preislistenkarte",
      "productCatalog": "Produktkatalog",
      "internalProductCatalog": "Interner Produktkatalog",
      "productConfiguration": "Produkt Konfiguration",
      "archivedConfiguration": "Archivierte Konfiguration",
      "marketAssociation": "Marktverband",
      "countries": "Länder",
      "markets": "Markt",
      "associatedMarkets": "Zugehörige Märkte",
      "featureFlags": "Feature-Flag",
      "images": "Bilder",
      "properties": "Property",
      "propertyAssociation": "Property Association Management",
      "featurePropertyAssociation": "Feature Property Association",
      "technicalInfo": "Technische Teileinformationen",
      "views": "Sicht",
      "multiNumericFeature": "Multinumerische",
      "notification": "Benachrichtigung",
      "queue": "Warteschlange",
      "productRelease": "Produktfreigabe",
      "productVersionMapping": "Produktversionszuordnung"
    },
    "reports": {
      "descopeList": "Descope-Liste",
      "extractForCoe": "Extract für"
    },
    "footer": {
      "env": "Umschl",
      "termsAndConitons": "Geschäftsbedingungen",
      "release": "R",
      "sprint": "SP",
      "build": "Bauen",
      "branch": "Zweig",
      "date": "Datum"
    },
    "messages": {
      "error": {
        "204": "Keine zu benachrichtigenden Konfigurationsänderungen",
        "400": "Ungültige Daten.",
        "401": "Sitzung abgelaufen, bitte melden Sie sich erneut an",
        "403": "Sie haben keinen Zugriff. Bitte wenden Sie sich an den Administrator.",
        "404": "Ressource nicht gefunden",
        "500": "Es ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut"
      },
      "success": {
        "create": "Erfolgreich erstellt!",
        "update": "Erfolgreich geupdated!",
        "delete": {
          "general": "Erfolgreich gelöscht",
          "users": "Erfolgreich gelöscht ({{length}}) Benutzer(s) : {{list}}",
          "roles": "Erfolgreich gelöscht ({{length}}) Rolle(n) : {{list}}",
          "apikeys": "Erfolgreich gelöscht ({{length}}) apikey(s) : {{list}}",
          "applications": "Erfolgreich gelöscht ({{length}}) Anwendung(en) : {{list}}",
          "languages": "Erfolgreich gelöscht ({{length}}) Sprache(n) : {{list}}",
          "markets": "Erfolgreich gelöscht ({{length}}) Markt(e): {{list}}",
          "featureFlags": "Erfolgreich gelöscht ({{length}}) feature flag(s) : {{list}}",
          "properties": "Successfully deleted ({{length}}) property(s) : {{list}}",
          "multiNumeric": "Erfolgreich gelöscht ({{length}}) Multinumerische : {{list}}",
          "prices": "Successfully deleted prices"
        },
        "import": "Datei-Upload erfolgreich. Daten werden importiert ...",
        "upload": {
          "general": "Daten erfolgreich hochgeladen!",
          "productHierarchy": "Daten-Upload erfolgreich.<1/>Bitte verwenden Sie die Schaltfläche „Vergleichen“, um die Änderungen anzuzeigen und zu veröffentlichen.",
          "technicalInfo": "<1>Erfolg</1> - Datenimport für {{file}} um {{timestamp}} erfolgreich"
        },
        "publish": "Daten erfolgreich veröffentlicht!",
        "discard": "Daten erfolgreich verworfen!",
        "retriggeredSuccessfully": "Erfolgreich erneut ausgelöst!"
      },
      "fail": {
        "create": "Erstellung fehlgeschlagen!",
        "update": "Aktualisierung fehlgeschlagen!",
        "download": "Download fehlgeschlagen!",
        "delete": {
          "general": "Löschen fehlgeschlagen",
          "users": "Fehler beim Löschen für Benutzer(s) ({{length}}): {{list}}",
          "roles": "Fehler beim Löschen für Rolle(n) ({{length}}): {{list}}",
          "apikeys": "Fehler beim Löschen für apikey(s) ({{length}}): {{list}}",
          "applications": "Fehler beim Löschen für Anwendung(en) ({{length}}): {{list}}",
          "languages": "Fehler beim Löschen für Sprache(n) ({{length}}): {{list}}",
          "markets": "Fehler beim Löschen für Markt(e) ({{length}}): {{list}}",
          "featureFlags": "Fehler beim Löschen für feature flag(s) ({{length}}): {{list}}",
          "properties": "Deletion failed for property(s) ({{length}}): {{list}}",
          "prices": "Deletion failied for prices",
          "multiNumeric": "Fehler beim Löschen für Multinumerische ({{length}}): {{list}}"
        },
        "export": "Export fehlgeschlagen!",
        "upload": "Upload fehlgeschlagen!",
        "import": "Der Import ist fehlgeschlagen!",
        "publish": "Veröffentlichung fehlgeschlagen!",
        "discard": "Verwerfen fehlgeschlagen!",
        "getDetails": "Es ist ein Fehler aufgetreten. Details können nicht abgerufen werden!",
        "fileSize": "Die Dateigröße darf nicht überschritten werden {{size}}MB",
        "fileFormat": "Es werden nur Dateien mit der Erweiterung {{format}} akzeptiert",
        "importWithFileInfo": "<1>Fehlgeschlagen</1> - Datenimport für {{file}} um {{timestamp}} fehlgeschlagen.",
        "importWithFileInfoAndLog": "<1>Fehlgeschlagen</1> - Datenimport für {{file}} um {{timestamp}} fehlgeschlagen. Weitere Informationen finden Sie in der heruntergeladenen Protokolldatei {{logFileName}}",
        "configurationId": "Konfigurations-ID ({{id}}) nicht gefunden",
        "fileName": "{{fileName}} - Name should be less than {{fileNameSize}} characters",
        "retriggeredFailed": "Erneutes Auslösen fehlgeschlagen!",
        "generate": "Generierung fehlgeschlagen!"
      },
      "confirmation": {
        "delete": {
          "applications": "Löschend '{{applicationNames}}'<br/>- InAktiviert alle entsprechenden Feature-Flags<br/>- Löscht alle Verknüpfungen mit dem API-Schlüssel<br/><br/>Diese Aktion kann nicht rückgängig gemacht werden.<br/><br/>Sind Sie sicher, dass Sie löschen möchten?",
          "featureFlags": "Löschend '{{featureFlagNames}}'<br/>- Löscht alle Verknüpfungen mit dem API-Schlüssel<br/><br/>Diese Aktion kann nicht rückgängig gemacht werden.<br/><br/>Sind Sie sicher, dass Sie löschen möchten?"
        }
      },
      "login": " bitte melden Sie sich erneut an",
      "session": "Sitzung abgelaufen,",
      "unauthenticated": "Benutzer ist nicht angemeldet. Bitte melden Sie sich an. Wenn das Problem weiterhin besteht, wenden Sie sich bitte an Ihren Administrator.",
      "tryAgain": "Bitte versuchen Sie es nach einiger Zeit erneut",
      "nameErrorMessage": "Bitte geben Sie einen gültigen Namen ein",
      "codeErrorMessage": "Bitte trage einen korrekten Code ein",
      "emailErrorMessage": "ungültiges Email-Format",
      "urlErrorMessage": "Ungültiges URL-Format",
      "deleteConfirmation": "Sind Sie sicher, dass Sie löschen möchten?",
      "deletePricesConfirmation": "Prices will be deleted permanently.<br/>Are you sure you want to continue?",
      "copyApiKeyMessage": "Das Abrufen des Schlüssels ist nicht möglich, sobald dieser Dialog geschlossen ist. Kopieren Sie den Schlüssel, um dieses Dialogfeld zu schließen.",
      "noServiceUserAvailable": "Kein Service-Benutzer verfügbar",
      "noSearchRecords": "Keine Datensätze gefunden für '{{searchValue}}'",
      "noDataFound": "Keine Daten gefunden.",
      "errorParsingLog": "Fehler beim Parsen des Protokolls",
      "noCountriesFound": "Keine Länder gefunden",
      "noApplicationsFound": "Keine Bewerbungen gefunden",
      "browserNotSupported": "Browser nicht unterstützt",
      "browserNotSupportedMessage": "Sie verwenden einen Browser oder eine Browserversion, die nicht offiziell unterstützt wird.<1/><1/>Sie können die Anwendung weiterhin verwenden oder für ein optimales Erlebnis eine der neuesten Versionen des unterstützten Browsers verwenden.",
      "supportedBrowsers": "Unterstützte Browser sind",
      "100LimitErrorMessage": "Bitte beschränken Sie den Text auf 100 Zeichen",
      "deleteLimitMessage": "Es können maximal {{limit}} Datensätze gleichzeitig gelöscht werden.",
      "logoutMessage": "Der Benutzer ist abgemeldet. Bitte melden Sie sich erneut zur Anwendung an.",
      "descriptionErrorMessage": "Bitte geben Sie eine gültige Beschreibung ein",
      "pageErrorMessage": "Bitte geben Sie eine gültige Seite ein",
      "maxLimitErrorMessage": "Nur {{limit}} Zeichen erlaubt.",
      "minLimitErrorMessage": "Minimum {{limit}} Zeichen erforderlich.",
      "invalidInputErrorMessage": "Ungültige Eingabe."
    }
  }
}